import FirebaseService from './firebase.service';

class ListasExpresService extends FirebaseService {
  constructor() {
    super('/listas-expres');
  }

  async listar(params = {}) {
    const res = await this.get('', params.status ? { status: params.status } : {});
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    return this.ensureArray(res);
  }

  async obtener(id) {
    const res = await this.get(`/${id}`);
    return res?.data || res;
  }

  async crear(payload) {
    const res = await this.post('', payload);
    return res?.data || res;
  }

  async actualizar(id, payload) {
    const res = await this.put(`/${id}`, payload);
    return res?.data || res;
  }

  async duplicar(id) {
    const res = await this.post(`/${id}/duplicar`, {});
    return res?.data || res;
  }

  async archivar(id) {
    const res = await this.post(`/${id}/archivar`, {});
    return res?.data || res;
  }
}

const listasExpresService = new ListasExpresService();
export default listasExpresService;
